const GENDER_MALE = 'Male';

const GENDER_FEMALE = 'Female';

export const genderOptions = [
  { value: '1', text: GENDER_MALE },
  { value: '2', text: GENDER_FEMALE },
];
